import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerCredencialRdp = ({ isOpen, toggle, selectedCredencial }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Credencial RDP</ModalHeader>
            <ModalBody>
                {selectedCredencial ? (
                    <div>
                        <p><strong>ID:</strong> {selectedCredencial.id}</p>
                        <p><strong>Username:</strong> {selectedCredencial.username}</p>
                        <p><strong>Contraseña:</strong> *****</p>
                        <p><strong>Hostname:</strong> {selectedCredencial.hostname}</p>
                        <p><strong>Puerto:</strong> {selectedCredencial.port}</p>
                        <p><strong>Nombre de Aplicación:</strong> {selectedCredencial.app_name || '-'}</p>
                        <p><strong>Directorio de Trabajo:</strong> {selectedCredencial.working_dir || '-'}</p>
                    </div>
                ) : (
                    <p>No se ha seleccionado una credencial RDP.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerCredencialRdp;
